import { types, flow, cast } from "mobx-state-tree";
import UserTypesModel from "./UserTypesModel";
import UsersModel from "./UsersModel";
import axios from "axios";

export default types
  .model("UsersState", {
    state: types.optional(types.array(UsersModel), []),
    userTypes: types.optional(types.array(UserTypesModel), []),
    updatedAt: types.optional(types.string, ""),
    loading: types.optional(types.boolean, false),
  })
  .actions((self) => ({
    FETCH_DATA: flow(function* () {
      self.loading = true;

      const { data } = yield axios.get("/api/users");
      //console.log("timerecordingmobxusers", data);
      self.state = cast(data);

      self.loading = false;
    }),

    FETCH_ONE_USER: flow(function* (id) {
      try {
        const { data } = yield axios.get(`/api/users/${id}`);
        //  self.state = cast(data);
      } catch (err) {
        throw err;
      }
      return true;
    }),

    FETCH_USER_TYPES: flow(function* () {
      const { data } = yield axios.get("/api/users/types");
      self.userTypes = cast(data);
    }),

    SEND_EMAIL: flow(function* (payload) {
      //console.log(payload);
      yield axios.post("/api/users/sendEmail", payload);
    }),

    ADD: flow(function* (payload) {
      const { data } = yield axios.post("/api/users", payload);
      self.state.push(data);
    }),

    UPDATE: flow(function* (id, values) {
      const { data } = yield axios.put(`/api/users/${id}`, values);
      self.state.splice(
        self.state.findIndex((data) => data.id === id),
        1,
        data
      );
    }),

    DELETE: flow(function* (id) {
      const { result } = yield axios.delete("/api/users", { data: { ids: [id] } });
      self.users.splice(
        self.users.findIndex((data) => data.id === id),
        1
      );
    }),
  }))
  .views((self) => ({}));
